<template>
  <div class="course-task-load-detail-contain">
    <section class="task-load-detail-filter clearfix">
      <div class="filter-lf">
        <div class="filter-lf-line clearfix">
          <div class="filter-module clearfix">
            <p class="filter-module-name">{{ $t('courseTask.taskName') }}</p>
            <div class="filter-module-value filter-module-value2">
              <el-input
                v-model="task.name"
                :disabled="true"
                size="small"
              ></el-input>
            </div>
          </div>
          <div class="filter-module clearfix">
            <p class="filter-module-name">{{ $t('courseTask.yearChose') }}</p>
            <div class="filter-module-value">
              <el-select v-model="task.year" :disabled="true">
                <el-option
                  v-for="item in yearList"
                  :key="'year'+item"
                  :label="item"
                  :value="item"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="filter-module clearfix">
            <p class="filter-module-name">{{ $t('courseTask.monthChose') }}</p>
            <div class="filter-module-value">
              <el-date-picker
                v-model="task.month"
                format="yyyy-MM"
                value-format="yyyy-MM"
                type="monthrange"
                size="small"
                :disabled="true"
                :range-separator="$t('datePicker.range')">
              </el-date-picker>
            </div>
          </div>
        </div>
        <div class="filter-lf-line clearfix">
          <div class="filter-module clearfix">
            <p class="filter-module-name">{{ $t('courseTask.maxWorking') }}</p>
            <div class="filter-module-value">
              <el-input-number v-model="task.maxWorking" :disabled="true"></el-input-number>
            </div>
          </div>
          <div class="filter-module clearfix">
            <p class="filter-module-name">{{ $t('courseTask.maxWorkingRelease') }}</p>
            <div class="filter-module-value">
              <el-input-number v-model="task.maxWorkingRelease" :disabled="true"></el-input-number>
            </div>
          </div>
          <div class="filter-module clearfix">
            <p class="filter-module-name">{{ $t('courseTask.isFirstTrainer') }}
               <el-tooltip placement="top-start" effect="light">
                <div slot="content">{{ $t("courseTask.isFirstTrainerInfo") }}</div>
                <em class="el-icon-question icon-blue"></em>
              </el-tooltip>
            </p>
            <div class="filter-module-value">
              <el-switch
                v-model="task.localTrainer"
                :disabled="true"
                :active-value="1"
                :inactive-value="0"
                active-text="是"
                inactive-text="否">
              </el-switch>
            </div>
          </div>
        </div>
        <div class="filter-lf-line clearfix">
          <div class="filter-module filter-module2 clearfix">
            <p class="filter-module-name">{{ $t('courseTask.taskRemark') }}</p>
            <div class="filter-module-value">
              <el-input
                v-model="task.taskRemark"
                :disabled="true"
                type="textarea"
                :rows="3"
                resize="none"
                class="isDetail"
              ></el-input>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="task-load-detail-content" v-if="loadShow">
      <article class="task-load-detail-operate">
        <el-button type="primary" @click="downDataList" :loading="downloadingData">
          {{ $t("export") }}
        </el-button>
      </article>
      <article class="task-load-detail-list"> 
        <el-table border class="course-task-table" ref="taskTable" 
          v-loading="taskLoading"
          :height="calHeight" 
          :data="taskData" 
          stripe 
          :span-method="arraySpanMethod">
          <el-table-column
            type="index"
            :label="$t('pop.no')"
            header-align="center"
            align="center"
            fixed
            width="55">
          </el-table-column>
          <template v-for="(item,kindex) in fcolumnList">
            <el-table-column :prop="item.prop"
                          :key="'courseSchedule'+item.prop"
                          show-overflow-tooltip
                          :width="item.width"
                          header-align="center"
                          align="center"
                          :fixed="item.prop === 'courseTeamCatalogNames' || item.prop === 'courseKindName' ||
                            item.prop === 'courseCode' ||item.prop === 'courseName'"
                          :formatter="item.formatter"
                          :label="item.label"
                          :render-header="item.prop === 'setMode' ? renderHeader : renderHeader2">
                <template slot-scope="scope">
                  <div :class="['course-task-value-link', {'course-task-value-link2': !scope.row['courseDays'] }]"
                  @click.stop="goCourse(scope.row)" v-if="item.prop === 'courseCode'">{{ scope.row[item.prop] + '(' + 
                  (scope.row['courseDays'] === null ? $t('courseTask.noValid') : 
                    scope.row['courseDays']) + ')' }}</div>
                  <div v-else-if="item.prop === 'setMode'">{{ filterSettingMode(scope.row[item.prop]) }}</div>
                  <div v-else-if="item.prop === 'courseName'" class="course-task-value-wrap">
                    {{ scope.row[item.prop] + '-' + scope.row['courseTotal'] }}</div>
                  <div v-else-if="item.prop === 'siteName'" class="course-task-value-wrap">{{ scope.row[item.prop]
                    + '-' + scope.row['total'] }}</div>
                  <div v-else-if="item.prop === 'district'" >
                    {{ scope.row[item.prop] + '-' + scope.row['districtTotal'] }}</div>
                  <div v-else-if="item.prop==='weekendArrangeFlag'">{{ filterWeekArrange(scope.row[item.prop]) }}</div>
                  <div v-else-if="item.prop.indexOf('Times') >= 0" >
                    {{ scope.row[item.prop] > 0 ? scope.row[item.prop] : null }}</div>
                  <div v-else>{{ scope.row[item.prop] }}</div>
                </template>
            </el-table-column>
          </template>
        </el-table>
      </article>
    </section>
    <section class="task-load-detail-footer" v-if="loadShow">
      <el-button @click="goPage" class="course-task-back">
        {{ $t("user.back") }}
      </el-button>
      <el-button type="success" :disabled="loadStatus !== 1" 
      @click="executionTask" v-if="taskStatus===1&&$hasPermission('AUTHLOADTASK')">
        {{ $t("courseTask.execution") }}
      </el-button>
    </section>
    <!-- 错误弹出 -->
    <errorModal v-if="errorVisible"
      :errorVisible="errorVisible"
      :isErrorContinue="isErrorContinue"
      @closeModal="closeError"
      :errorData="errorData"
      :taskType="taskType"
      :errorTitle="task.name"
      :taskName="task.name">
    </errorModal>
  </div>
</template>
<script>
import dayjs from 'dayjs';
import errorModal from './courseCheckModal.vue';

export default {
  components: {
    errorModal
  },
  data() {
    return {
      task: {
        name: '',
        year: new Date().getFullYear(),
        month: [],
        maxWorking: 15,
        maxWorkingRelease: 5,
        taskRemark: '',
        localTrainer: 1
      },
      taskType: 0,
      yearList: [new Date().getFullYear(), new Date().getFullYear() + 1],
      taskLoading: false,
      settingList: this.enums['yearTargetSetMode'],
      weekClassList: this.enums['weekArrangeFlag'],
      columnList: [
        { label: this.$t('courseSchedule.courseGroup'), prop: 'courseTeamCatalogNames', width: 120 },
        { label: this.$t('courseSchedule.courseType'), prop: 'courseKindName' },
        { label: this.$t('courseSchedule.courseIndex'), prop: 'courseCode', width: 130 },
        { label: this.$t('courseSchedule.courseCalculate'), prop: 'courseName', width: 120 },
        { label: this.$t('courseSchedule.weekendClass'), prop: 'weekendArrangeFlag', width: 100 },
        { label: this.$t('courseSchedule.areaCalculate'), prop: 'district'},
        { label: this.$t('courseSchedule.siteCalculate'), prop: 'siteName', width: 210 },
        { label: this.$t('courseSchedule.settingMode'), prop: 'setMode', width: 120 },
        { label: this.$t('courseSchedule.targetNum'), prop: 'total'}   
      ],
      fcolumnList: [],
      spanArr1: [],
      spanArr2: [],
      spanArr3: [],
      spanArr4: [],
      spanArr5: [],
      taskData: [],
      loadShow: false,
      downloadingData: false,
      isEdit: false,
      loadStatus: -1,
      taskId: '',
      errorVisible: false,
      errorData: '',
      isErrorContinue: false,
      taskStatus: 0,
      calHeight: 400
    };
  },
  methods: {
    renderHeader (h, {column}) {
      return h('div', [
        h('span', column.label),
          h(
            'el-tooltip',
            {
                props: {
                  effect: 'light',
                  content: this.$t('courseTask.settingModeInfo'),
                  placement: 'top',
                },
            },
            [
              h('i', {
                  class: 'el-icon-question',
                  style: 'color:#409eff;margin-left:5px;',
              }),
            ],
          ),
      ]);
    },
    renderHeader2 (h, {column}) {
      return h('div', [
        h('span', column.label)
      ]);
    },
    filterSettingMode (val) {
      const [obj] = this.settingList.filter((item)=> Number(val) === Number(item.code));
      return obj.name;
    },
    filterWeekArrange (val) {
      const [obj] = this.weekClassList.filter((item)=> Number(val) === Number(item.code));
      return obj.name;
    },
    getMonthColumnList (start, end) {
      this.fcolumnList = [].concat(this.columnList);
      const monthArr = [
        { label: '1'+this.$t('courseSchedule.month'), prop: 'janTimes' },
        { label: '2'+this.$t('courseSchedule.month'), prop: 'febTimes' },
        { label: '3'+this.$t('courseSchedule.month'), prop: 'marTimes' },
        { label: '4'+this.$t('courseSchedule.month'), prop: 'aprTimes' },
        { label: '5'+this.$t('courseSchedule.month'), prop: 'mayTimes' },
        { label: '6'+this.$t('courseSchedule.month'), prop: 'junTimes' },
        { label: '7'+this.$t('courseSchedule.month'), prop: 'julTimes' },
        { label: '8'+this.$t('courseSchedule.month'), prop: 'augTimes' },
        { label: '9'+this.$t('courseSchedule.month'), prop: 'sepTimes' },
        { label: '10'+this.$t('courseSchedule.month'), prop: 'octTimes' },
        { label: '11'+this.$t('courseSchedule.month'), prop: 'novTimes' },
        { label: '12'+this.$t('courseSchedule.month'), prop: 'decTimes' }
      ];
      for(let i=start;i <= end; i++) {
        this.fcolumnList.push(monthArr[i]);
      }
    },
    resetArraySpan () {
      this.spanArr1 = [];
      this.spanArr2 = [];
      this.spanArr3 = [];
      this.spanArr4 = [];
      this.spanArr5 = [];
    },
    // 合并单元格
    arraySpanMethod ({ _row, _column, rowIndex, columnIndex }) {
      if (columnIndex === 1) {
        return {
          rowspan: this.spanArr1[rowIndex],
          colspan: this.spanArr1[rowIndex] > 0 ? 1 : 0
        };
      } else if (columnIndex === 2) {
        return {
          rowspan: this.spanArr2[rowIndex],
          colspan: this.spanArr2[rowIndex] > 0 ? 1 : 0
        };
      } else if (columnIndex === 3) {
        return {
          rowspan: this.spanArr3[rowIndex],
          colspan: this.spanArr3[rowIndex] > 0 ? 1 : 0
        };
      } else if (columnIndex === 4 || columnIndex === 5) {
        return {
          rowspan: this.spanArr4[rowIndex],
          colspan: this.spanArr4[rowIndex] > 0 ? 1 : 0
        };
      } else if (columnIndex === 6) {
        return {
          rowspan: this.spanArr5[rowIndex],
          colspan: this.spanArr5[rowIndex] > 0 ? 1 : 0
        };
      }
    },
    mergeData () {
      let index1 = 0;
      let index2 = 0;
      let index3 = 0;
      let index4 = 0;
      let index5 = 0;
      const data = this.taskData;
      for(let [k, i] of data.entries()) {
        if (k === 0) {
          this.spanArr1.push(1);
          this.spanArr2.push(1);
          this.spanArr3.push(1);
          this.spanArr4.push(1);
          this.spanArr5.push(1);
        } else {
          if (i.courseTeamCatalogNames === data[k - 1].courseTeamCatalogNames &&
          i.courseCode === data[k-1].courseCode) {
            this.spanArr1[index1] += 1;
            this.spanArr1.push(0);
          } else {
            this.spanArr1.push(1);
            index1 = k;
          }
          if (i.courseCode === data[k-1].courseCode && i.courseKindName === data[k-1].courseKindName) {
            this.spanArr2[index2] += 1;
            this.spanArr2.push(0);
          } else {
            this.spanArr2.push(1);
            index2 = k;
          }
          if (i.courseCode === data[k-1].courseCode) {
            this.spanArr3[index3] += 1;
            this.spanArr3.push(0);
          } else {
            this.spanArr3.push(1);
            index3 = k;
          }
          if (i.courseTeamCatalogNames === data[k-1].courseTeamCatalogNames &&
          i.courseKindName === data[k-1].courseKindName && i.courseCode === data[k-1].courseCode &&
          i.courseName === data[k-1].courseName) {
            this.spanArr4[index4] += 1;
            this.spanArr4.push(0);
          } else {
            this.spanArr4.push(1);
            index4 = k;
          }
          if (i.courseTeamCatalogNames === data[k-1].courseTeamCatalogNames &&
          i.courseKindName === data[k-1].courseKindName && i.courseCode === data[k-1].courseCode &&
          i.courseName === data[k-1].courseName && i.district === data[k-1].district) {
            this.spanArr5[index5] += 1;
            this.spanArr5.push(0);
          } else {
            this.spanArr5.push(1);
            index5 = k;
          }
        }
      }
    },
    goCourse (val) {
      if (!val.courseDays) {
        return false;
      }
      if (val.courseType === 'courseKind') {
        this.$router.push({
          name: 'learning-course-courseShow',
          query: {
            courseId: val.courseId
          }
        });
        this.$eventHub.$emit('showViewCourse', '');
      } else {
        this.$router.push({
          name: 'rm-courseGroup-courseGroupDetail',
          query: {
            id: val.courseId
          }
        });
        this.$eventHub.$emit('courseGroupDetail', '');
      }
    },
    goPage () {
      this.resetList();
      this.tabRemove();
      this.$router.push({
        name: 'rm-courseTask-courseTaskManage'
      });
      this.$eventHub.$emit('courseTaskManage', true);
    },
    executionTask () {
      this.taskLoading = true
      this.$request.post(`/classschedule/coursePkgCheck/checkTaskWhenExecute?taskId=${this.taskId}`)
      .then((res) => {
        if (res) {
          this.isErrorContinue = false;
          if (res.status === -1 ) {
            this.errorData = res.data;
            this.errorVisible = true;
            this.taskLoading = false;
          } else if (res.status === -2) { 
            this.$message({
              message: res.message,
              type: 'warning',
            });
            this.taskLoading = false;
          } else if (res.status === -3) { 
            this.errorData = res.data;
            this.errorVisible = true;
            this.isErrorContinue = true;
            this.taskLoading = false;
          } else {
            this.errorVisible = false;
            this.executionTaskFinal(this.taskId);
          } 
        }
      }).catch(() => {
        this.taskLoading = false;
      });
    },
    executionTaskFinal (id) {
      this.taskLoading = true;
      this.$request.post(`/classschedule/scheduleTask/executeTask?scheduleTaskId=${id}`)
      .then((_res, _total, code, data) => {
        if (code === 10000006) {
          this.$confirm(data.msg, this.$t('prompt.title'), {
            confirmButtonText: this.$t('confirm'),
            cancelButtonText: this.$t('cancel'),
            type: 'warning'
          }).then(() => {
            this.sureQueue(id);
          }).catch(() => {
            this.taskLoading = false;
          });
        } else {
          this.$message({
            message: this.$t('courseTask.executionSuccess'),
            type: 'success',
          });
          this.taskLoading = false;
          this.goPage();
        }
      }).catch(() => {
        this.$message({
          message: this.$t('courseTask.executionFailed'),
          type: 'warning',
        });
        this.taskLoading = false;
        this.goPage();
      });
    },
    sureQueue (id) {
      this.$request.post(`/classschedule/scheduleTask/confirmInQueue?scheduleTaskId=${id}`).then(() => {
        this.taskLoading = false;
        this.goPage();
      }).catch(() => {
        this.taskLoading = false;
      });
    },
    downDataList () {
      clearTimeout(this.timeout);
      const params = {
        id: this.taskId
      };
      this.downloadingData = true;
      this.$request.downloadByPost7(
        '/classschedule/scheduleTask/export',
        `${this.task.name + this.$t('courseTask.loadTaskDownload') 
        + dayjs().format('YYYY-MM-DD HH:mm:ss') }.xls`,
        params, null, 'xls'
      );
      this.$message({
        message: this.$t('courseSchedule.downloading'),
        type: 'success',
      });
      this.timeout = setTimeout(() => {
        this.downloadingData = false;
      }, 2000);
    },
    getDetail () {
      this.resetList();
      this.$request.get('/classschedule/scheduleTask/getByTaskId', { id: this.$route.query.taskId })
      .then((res) => {
        if (res) {
          this.task.maxWorking = res.maxContinuousDays;
          this.task.maxWorkingRelease = res.restDays;
          this.task.year = res.arrangeStartDate.substr(0,4);
          this.loadShow = true;
          this.task.name = res.taskName;
          this.task.taskRemark = res.remark;
          this.task.localTrainer = res.localTrainer;
          this.loadStatus = res.status;
          this.taskStatus = res.status;
          const beginMonth = new Date(res.arrangeStartDate).getMonth() + 1;
          const endMonth = new Date(res.arrangeEndDate).getMonth() + 1;
          this.task.month = [
            `${this.task.year  }-${  beginMonth < 10 ? '0' + beginMonth : beginMonth.toString()}`,
            `${this.task.year  }-${  endMonth < 10 ? '0' + endMonth : endMonth.toString()}`
          ]
          this.getMonthColumnList(beginMonth - 1, endMonth - 1);
          this.taskData = res.targetRecords.map((item) => {
            return { ...item,
            weekendArrangeFlag: item.weekendArrangeFlag.toString(),
            setMode: item.setMode.toString() };
          });
          this.resetArraySpan();
          this.mergeData();
        }
      })
    },
    resetList () {
      this.task = {
        name: '',
        year: new Date().getFullYear(),
        month: [],
        maxWorking: 15,
        maxWorkingRelease: 5,
        taskRemark: ''
      };
      this.taskData = [];
      this.loadShow = false;
    },
    closeError (val) {
      this.errorVisible = false;
      this.errorData = null;
      if (val) {
        this.executionTaskFinal(this.taskId);
      } else {
        this.taskLoading = false;
      }
    },
    // 删除当前页面
    tabRemove() {
      const tabName = this.$store.state.contentTabsActiveName;
      if (tabName === 'home') {
        return false;
      }
      this.$store.state.contentTabs = this.$store.state.contentTabs.filter(item => item.name !== tabName)
      if (this.$store.state.contentTabs.length <= 0) {
        this.$store.state.sidebarMenuActiveName = this.$store.state.contentTabsActiveName = 'home';
        return false;
      }
      if (tabName === this.$store.state.contentTabsActiveName) {
        this.$router.push({name: this.$store.state.contentTabs[this.$store.state.contentTabs.length - 1].name});
      }
    },
  },
  watch: {
    $route () {
      if (this.$route.name === 'rm-courseTask-courseTaskLoadDetail') {
        this.taskId = this.$route.query.taskId;
      }
    },
    taskId () {
      this.getDetail();
    }
  },
  mounted() {
    this.taskId = this.$route.query.taskId;
    setTimeout(() => {
      this.calHeight = window.innerHeight - 100;
    });
    window.onresize = () => {
      setTimeout(() => {
        this.calHeight = window.innerHeight - 100;
      });
    };
  },
  destroyed() {
    clearTimeout(this.timeout);
    this.timeout = null;
    this.taskId = '';
    this.isEdit = false;
    this.resetList();
  }
};
</script>
<style lang="scss" scoped>
.course-task-load-detail-contain {
  min-height: calc(100% - 120px);
  .task-load-detail-filter {
    display: flex;
    background-color: #fff;
    padding: 15px;
    margin-bottom: 12px;
    .filter-lf {
      flex: 8;
      padding-right: 20px;
      .filter-lf-line {
        line-height: 34px;
        margin-bottom: 12px;
        .filter-module {
          float: left;
          width: calc(33.33% - 20px);
          margin-right: 20px;
          &.filter-module2 {
            width: calc(100% - 20px);
          }
          .filter-module-name {
            line-height: 26px;
            margin: 0;
          }
        }
      }
    }
    .filter-lr {
      flex: 1;
      vertical-align: middle;
      padding: 26px 20px 0 0;
      .button-margin-b {
        margin-bottom: 7px;
      }
    }
  }
  .task-load-detail-content {
    background-color: #fff;
    padding: 15px;
    margin-bottom: 12px;
    .task-load-detail-operate {
      margin-bottom: 12px;
    }
    .task-load-detail-list {
      .course-task-table {
        width: 100%;
      }
    }
    .course-task-value-wrap {
      word-break: break-word;
      white-space: initial;
    }
    .course-task-value-link {
      color: #409eff;
      cursor: pointer;
      text-decoration: underline;
      word-break: break-word;
      white-space: pre-wrap;
      &.course-task-value-link2 {
        color: #606266;
        cursor: default;
      }
    }
  }
  .task-load-detail-footer {
    text-align: right;
    background-color: #fff;
    padding: 15px;
  }
  .icon-blue {
    color: #409eff;
  }
}
</style>
<style lang="scss">
.course-task-load-detail-contain{
  .isDetail {
    padding: 0 0px 0 0 !important;
  }
  .filter-module-value2 {
    .el-input__inner {
      padding-right: 65px !important;
    }
    .el-input__count-inner {
      background-color: transparent !important;
    }
  }
  .el-range-editor.el-input__inner {
    width: 100% !important;
  }
  .el-range-editor--small .el-range-separator {
    line-height: 32px !important;
  }
  .el-input-number{
    line-height: 32px !important;
    width: 100% !important;
  }
  .el-input__inner {
    line-height: 32px !important;
  }
  .el-button--default:hover {
    color: #409eff !important;
    border-color: #c6e2ff !important;
    background-color: #ecf5ff !important;
  }
  .el-button--primary:hover {
    background: #66b1ff !important;
    border-color: #66b1ff !important;
    color: #fff !important;
  }
  .el-button--success:hover, .el-button--success:focus {
    background: #85ce61 !important;
    border-color: #85ce61 !important;
    color: #fff !important;
  }
  .el-button--success:active {
    background: #85ce61 !important;
    border-color: #85ce61 !important;
    color: #fff !important;
    opacity: .9;
  }
  .el-button--info {
    background: #535151!important;
    border: 1px solid #535151 !important;
    color: #fff !important;
  }
  .el-button--info:hover {
    opacity: .8;
    background: #535151!important;
    border: 1px solid #535151 !important;
    color: #fff !important;
  }
  .course-task-select {
    .el-input__inner {
      text-align: center !important;
    }
  }
  .course-task-back {
    &:focus {
      border-color: #c6e2ff !important;
      background-color: #ecf5ff !important;
    }
  }
}
</style>